import React, { useEffect, useState } from 'react';
import { sha256 } from 'js-sha256';
import Button from '@/components/Button';
import { getCookie, setCookie } from '@/utils/cookies';

type PasswordGateProps = {
  isProtected: boolean;
  children: React.ReactNode;
};

const PASSWORD_HASH = __PROTECTED_PAGE_PASSWORD_HASH__;
const COOKIE_NAME = 'protected_page_access';

const PasswordGate = ({ isProtected, children }: PasswordGateProps) => {
  const [hasAccess, setHasAccess] = useState(!isProtected);
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isProtected) {
      return;
    }
    const cookieValue = getCookie(COOKIE_NAME);
    setHasAccess(cookieValue === 'true');
  }, [isProtected]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const hashedInput = sha256(input).toString();

    if (hashedInput === PASSWORD_HASH) {
      setCookie(COOKIE_NAME, 'true', 7); // acceso válido por 7 días
      setHasAccess(true);
    } else {
      setError('Incorrect password');
    }
  };

  if (!hasAccess) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md">
          <h1 className="text-center text-xl font-semibold bg-green-600 text-white py-2 px-4 rounded-md mb-6">
            This page is protected
          </h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <label className="block text-sm font-poppins-semi-bold text-gray-700">
              Enter Password
              <input
                type="password"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                className="mt-1 block w-full py-2 border border-gray-300 rounded-md shadow-sm focus:ring-green-500 focus:border-green-500"
              />
            </label>
            {error && (
              <p className="text-sm text-red-500">{error}</p>
            )}
            <div className="flex justify-center">
              <Button variant="primary" type="submit">Unlock Page</Button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return children;
};

export default PasswordGate;
